<template>
    <div class="loading" :class="{show:showLoading}">
        <div class="overlay">

        </div>
        <div class="animation-container">
            <div class="loader-2"><span class="loader-inner"></span></div>
        </div>
        <div class="progress-container" v-show="loadingProgress > 0">
            <div class="progress"><span class="progress-inner" :style="{'width':loadingProgress+'%'}"></span></div>
        </div>
    </div>
</template>

<script>
    //import Component from 'path/to/component'
    import {mapGetters} from 'vuex';

    import LoadingIcon from '@a/img/loading.svg'

    export default {
        beforeCreate: function () {

        },
        beforeDestroy: function () {

        },
        beforeMount: function () {

        },
        beforeUpdate: function () {

        },
        components: {
            LoadingIcon
        },
        computed: {
            ...mapGetters({
                showLoading: 'UI/showLoading',
                loadingProgress: 'UI/loadingProgress'
            })
        },
        created: function () {

        },
        data() {
            return {}
        },
        destroyed: function () {

        },
        methods: {},
        mounted: function () {

        },
        name: 'Loading',
        props: {},
        updated: function () {

        },
        watch: {}
    }
</script>

<style lang="scss">
  .loading {
      height: 100%;
      left: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 100000000000000000000;
      opacity: 0;
      transition-property: opacity, transform;

      .overlay {
          background-color: rgba($main-color, 1);
          height: 100%;
          left: 0;
          position: absolute;
          top: 0;
          width: 100%;
      }
      .animation-container {
          color: $main-white;
          left: 50%;
          position: absolute;
          transform: translate(-50%, -50%) /*scale(1.5,1.5)*/;
          top: 50%;
          z-index: 2;

          .loader-2 {
              display: inline-block;
              width: 45px;
              height: 45px;
              position: relative;
              border: 5px solid $main-white;
              animation: loader 3s infinite ease;
          }
          .loader-inner {
              vertical-align: top;
              display: inline-block;
              width: 100%;
              background-color: $main-white;
              border: 2px solid $main-color;
              animation: loader-inner 3s infinite ease-in;
          }
      }
      .progress-container {
          color: $main-white;
          left: 50%;
          position: absolute;
          transform: translate(-50%, -50%) /*scale(1.5,1.5)*/;
          top: 60%;
          z-index: 2;
          opacity: 0.5;

          .progress {
              display: inline-block;
              width: 100px;
              height: 10px;
              position: relative;
              border: 1px solid $main-white;
              //animation: loader 3s infinite ease;
          }
          .progress-inner {
              vertical-align: top;
              display: inline-block;
              height: 100%;
              background-color: $main-white;
              border: solid 1px $main-color;
              transition: width 300ms ease-out;
              //animation: loader-inner 3s infinite ease-in;
          }
      }
      &.show {
          opacity: 1;
          transform: scale(1, 1);
          pointer-events: all;
      }
  }
  @keyframes loader {
      0% {
          transform: rotate(0deg);
      }
      25% {
          transform: rotate(180deg);
      }
      50% {
          transform: rotate(180deg);
      }
      75% {
          transform: rotate(360deg);
      }
      100% {
          transform: rotate(360deg);
      }
  }
  @keyframes loader-inner {
      0% {
          height: 0%;
      }
      25% {
          height: 0%;
      }
      50% {
          height: 100%;
      }
      75% {
          height: 100%;
      }
      100% {
          height: 0%;
      }
  }

  .sfr {
    .loading {
      height: 100%;
      left: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 100000000000000000000;
      opacity: 0;
      transition-property: opacity, transform;

      .overlay {
        background-color: rgba($main-black, 1);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }
      .animation-container {
        color: $sfr-color;
        left: 50%;
        position: absolute;
        transform: translate(-50%, -50%) /*scale(1.5,1.5)*/;
        top: 50%;
        z-index: 2;

        .loader-2 {
          display: inline-block;
          width: 45px;
          height: 45px;
          position: relative;
          border: 5px solid $sfr-color;
          animation: loader 3s infinite ease;
        }
        .loader-inner {
          vertical-align: top;
          display: inline-block;
          width: 100%;
          background-color: $sfr-color;
          border: 2px solid $main-black;
          animation: loader-inner 3s infinite ease-in;
        }
      }
      .progress-container {
        color: $sfr-color;
        left: 50%;
        position: absolute;
        transform: translate(-50%, -50%) /*scale(1.5,1.5)*/;
        top: 60%;
        z-index: 2;
        opacity: 0.5;

        .progress {
          display: inline-block;
          width: 100px;
          height: 10px;
          position: relative;
          border: 1px solid $sfr-color;
          //animation: loader 3s infinite ease;
        }
        .progress-inner {
          vertical-align: top;
          display: inline-block;
          height: 100%;
          background-color: $sfr-color;
          border: solid 1px $main-black;
          transition: width 300ms ease-out;
          //animation: loader-inner 3s infinite ease-in;
        }
      }
      &.show {
        opacity: 1;
        transform: scale(1, 1);
        pointer-events: all;
      }
    }
  }
  .beepiz {
    .loading {
      height: 100%;
      left: 0;
      pointer-events: none;
      position: absolute;
      top: 0;
      width: 100%;
      z-index: 100000000000000000000;
      opacity: 0;
      transition-property: opacity, transform;

      .overlay {
        background-color: rgba($main-black, 1);
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
      }
      .animation-container {
        color: $beepiz-color;
        left: 50%;
        position: absolute;
        transform: translate(-50%, -50%) /*scale(1.5,1.5)*/;
        top: 50%;
        z-index: 2;

        .loader-2 {
          display: inline-block;
          width: 45px;
          height: 45px;
          position: relative;
          border: 5px solid $beepiz-color;
          animation: loader 3s infinite ease;
        }
        .loader-inner {
          vertical-align: top;
          display: inline-block;
          width: 100%;
          background-color: $beepiz-color;
          border: 2px solid $main-black;
          animation: loader-inner 3s infinite ease-in;
        }
      }
      .progress-container {
        color: $main-white;
        left: 50%;
        position: absolute;
        transform: translate(-50%, -50%) /*scale(1.5,1.5)*/;
        top: 60%;
        z-index: 2;
        opacity: 0.5;

        .progress {
          display: inline-block;
          width: 100px;
          height: 10px;
          position: relative;
          border: 1px solid $main-white;
          //animation: loader 3s infinite ease;
        }
        .progress-inner {
          vertical-align: top;
          display: inline-block;
          height: 100%;
          background-color: $main-white;
          border: solid 1px $main-black;
          transition: width 300ms ease-out;
          //animation: loader-inner 3s infinite ease-in;
        }
      }
      &.show {
        opacity: 1;
        transform: scale(1, 1);
        pointer-events: all;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ui/Loading.vue